import {
  Button,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { RemoveCircleOutline } from "@mui/icons-material";

import nameof from "ts-nameof.macro";

import { Rules } from "../../common/validationRules";
import notaryService from "../../services/notaryService";
import { PageDefaults } from "../../common/interfaces/PageDto";
import { ReportSearchDto, ReportSearchResultDto } from "../../interfaces/Report";
import DatePickerExtended from "../../common/components/mui-extended/DatePickerExtended";
import SectionExtended from "../../common/components/mui-extended/SectionExtended";
import { PublicRoutesConfig } from "../RoutesConfig";
import useUserContext from "../../hooks/useUserContext";
import { useSearchForm } from "../../common/hooks/useSearchForm";

export default function Report() {
  const { userId } = useUserContext();

  const defaultModel: ReportSearchDto = {
    ...PageDefaults,
    userId: userId,
    endDate: new Date(),
  };

  const form = useSearchForm<ReportSearchDto, ReportSearchResultDto>({
    defaultModel: defaultModel,
    rootSearchPath: PublicRoutesConfig.Report.Search.Path,
    searchAsync: async (query: string) => {
      await notaryService.getReportResultsAsync(query).then(async ({ data }) => {
        form.setResults(data, data.length);
      });
    },
  });

  const renderForm = () => {
    return (
      <form onReset={form.onReset} onSubmit={form.onSubmit}>
        <Stack spacing={3}>
          <SectionExtended title="Период на справката">
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <DatePickerExtended
                  label="Начална дата"
                  name={nameof(defaultModel.startDate)}
                  form={form}
                  maxDate={form.watch(nameof(defaultModel.endDate)) || new Date()}
                  rules={{ ...Rules.Required, ...Rules.Date }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <DatePickerExtended
                  label="Крайна дата"
                  name={nameof(defaultModel.endDate)}
                  form={form}
                  minDate={form.watch(nameof(defaultModel.startDate))}
                  maxDate={new Date()}
                  rules={{ ...Rules.Required, ...Rules.Date }}
                />
              </Grid>
            </Grid>
          </SectionExtended>
          <Grid container justifyContent="space-between">
            <Grid item>
              <Button startIcon={<RemoveCircleOutline />} type="reset">
                Изчисти
              </Button>
            </Grid>
            <Grid item>
              <Stack direction="row" spacing={1}>
                <Button startIcon={PublicRoutesConfig.Report.Search.Icon} type="submit">
                  {PublicRoutesConfig.Report.Search.Label}
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Stack>
      </form>
    );
  };

  const renderTable = () => {
    return form.results && form.results.length > 0 ? (
      <>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell width="50%" align="right" sx={{ pr: 3 }}>
                  Регистър
                </TableCell>
                <TableCell>Брой справки</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {form.results.map((item) => (
                <TableRow key={item.registerType} hover>
                  <TableCell sx={{ p: 2, pr: 3 }} align="right">
                    {item.registerType}
                  </TableCell>
                  <TableCell>{item.count}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    ) : null;
  };

  return (
    <Stack spacing={3}>
      <Typography variant="h5">Индивидуална справка</Typography>
      {renderForm()}
      {renderTable()}
    </Stack>
  );
}
